<template>
  <div>
    <crud-layout
      ref="crudLayout"
      :name="$gettext('ORDER_GENERATE')"
      :params="params"
      :page-search="pageSearch"
      :interface="nmInterface"
      clean-layout
      :row-buttons="false"
      :staticTabs="false"
      @items="itemsSelection"
    />
    <modal
      ref="scheduleOrderModal"
      :show="flModalSchedule"
      :forms="formsModalSchedule"
      @action-button="actionButtonSchedule"
    />
    <modal
      ref="filterModal"
      :show="modalFilter.flFilter"
      :forms="modalFilter.formsModalFilter"
      @action-button="actionButtonFilter"
    />
    <generator-order-emission-modal
      ref="emissionModal"
      :itemsLateGroup="itemsLateGroup"
      :show="flModalEmission"
      :forms="formsModalEmisson"
      @action-button="actionButtonEmission"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import GeneratorOrderPageSearch from './GenaratorOrderPageSearch.vue'
import GenaratorOrderPageSearchTable from './GenaratorOrderPageSearchTable.vue'
import GeneratorOrderEmissionModal from './GeneratorOrderEmissionModal.vue'
import { repository, messageBox } from 'jtech'
import moment from 'moment'
import GeneratorOrderEvent from './GeneratorOrderEvent'
import GenerateOrderState from './GenerateOrderState'

const { CrudLayout, modal } = JtCrud

@Component({
  name: 'GeneratorOrder',
  components: { CrudLayout, modal, GeneratorOrderEmissionModal },
  props: {
    id: String,
    interface: String,
    name: String,
    params: Object
  }
})
class GeneratorOrder extends Vue {
  state = GenerateOrderState.getInstance();
  flModalSchedule = false;
  flModalEmission = false;
  batchData = [];
  controller = []
  modalFilter = {
    flFilter: false,
    formsModalFilter: [{ dadosForm: { isGroupOrder: false } }],
    page: undefined
  }

  formsModalEmisson = null;
  formsModalSchedule = null;

  itemsSelection = [];
  itemsLateGroup = [];
  moment = moment;

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btOpenBatch', this.openBatch)
      this.$refs.crudLayout.onButton('btFilter', this.openFilter)
      this.$refs.crudLayout.onButton('btGenerateOrder', this.generateOrder)
      this.$refs.crudLayout.onButton('btScheduleOrder', this.scheduleOrder)
    } catch (error) {
      console.error(error)
    }
  }

  itemsSelection (items) {
    this.itemsSelection = items
  }

  async openFilter ({ page }) {
    const forms = await repository.resolve(
      'controlBatch.filter'
    )
    this.modalFilter.formsModalFilter = [{ ...forms[0], dadosForm: this.modalFilter.formsModalFilter[0].dadosForm }]
    this.modalFilter.page = page
    this.modalFilter.flFilter = true
  }

  async scheduleOrder () {
    this.formsModalSchedule = await repository.resolve(
      'controlBatch.scheduleOrder'
    )
    this.flModalSchedule = true
  }

  async actionButtonEmission (button, params) {
    const itemsSelection =
      this.$refs.crudLayout.$refs.containerRef.container.pages[1].params
        .itemsSelection

    await repository.resolveLogic('billingOrder.gravarPedidoAutomatico', {
      grid: { ...itemsSelection },
      emission: params.emission,
      automatic: true,
      ...this.batchData
    })
    GeneratorOrderEvent.$emit('refresh-page')
    this.$refs.emissionModal.hide()
    this.flModalEmission = false
  }

  actionButtonFilter (button, params) {
    this.modalFilter.page.$refs.jtDataTable.extraParams = { ...this.modalFilter.page.$refs.jtDataTable.extraParams, ...params }
    this.modalFilter.page.$refs.jtDataTable.refresh()
    this.modalFilter.flFilter = false
  }

  async actionButtonSchedule ({ a, b }) {
    const itemsSelection =
      this.$refs.crudLayout.$refs.containerRef.container.pages[1].params
        .itemsSelection
    const dateTime =
      this.$refs.scheduleOrderModal.forms[0].dadosForm.dateTime.split(' ')

    if (moment().isBefore(moment(dateTime[0]), moment())) {
      await repository.create('billingOrder.gravarPedidoAgendado', {
        grid: JSON.stringify(itemsSelection),
        date: dateTime[0],
        time: dateTime[1]
      })
      this.flModalSchedule = false
    } else {
      messageBox.warn(this.$gettext('APPOINTMENT_DATE_ERROR'))
    }
  }

  async generateOrder (e) {
    delete e.params.id_funcionalidade
    this.itemsLateGroup = Object.values(e.params).filter((item) => {
      return item.idBillingOrderToGroup
    })
    this.formsModalEmisson = await repository.resolve(
      'controlBatch.emissonOrder'
    )
    const newInputPossibleGroup = this.formsModalEmisson[0].inputs[1]
    this.formsModalEmisson[0].inputs.splice(1, 1)

    this.itemsLateGroup.forEach((order, index) => {
      newInputPossibleGroup.dataName = `order-${order.id}`
      newInputPossibleGroup.label = `${this.$gettext('GROUP_ORDER')} ${order.clientName}`
      newInputPossibleGroup.model = `order-${order.id}`
      this.formsModalEmisson[0].inputs.push({ ...newInputPossibleGroup })

      const idsPossibleGroups = JSON.parse(order.idBillingOrderToGroup)
      this.formsModalEmisson[0].relacionamentos[`order-${order.id}`] = idsPossibleGroups.map(id => {
        return { label: id, value: id }
      })
    })

    this.flModalEmission = true
  }

  beforeDestroy () {
    this.removeOpenPage()
  }

  removeOpenPage () {
    this?.controller?.removePage(this?.$refs?.crudLayout?.$refs?.containerRef?.container?.pages[1])
  }

  async openBatch ({ params, controller }) {
    this.controller = controller
    delete params.id_funcionalidade
    const dataTable = await repository.resolveDatatable(
      'controlBatchTicket.pesquisar'
    )
    delete params.id_funcionalidade

    if (this.isATabAlreadyOpen()) {
      this.removeOpenPage()
    }

    controller.addPage({
      type: 'table',
      label: this.$gettext('ORDER_GENERATE'),
      params: {
        totalByContract: params[0].totalByContract,
        totalContractMaintenance: params[0].totalContractMaintenance,
        totalByTicket: params[0].totalByTicket,
        controlBatch: params.id ? params.id : params[0].id,
        itemsSelection: this.itemsSelection,
        ...this.modalFilter.formsModalFilter[0].dadosForm,
        totalPreBillingOrder: params[0].totalPreBillingOrder
      },
      component: this.pageSearchItem,
      flClose: true,
      datatable: dataTable
    })
    this.batchData = { ...params[0] }
    this.batchData.code = this.batchData.id
    this.state.setActualBatchInfos(this.batchData)
  }

  isATabAlreadyOpen () {
    return this?.$refs?.crudLayout?.$refs?.containerRef?.container?.pages[1]
  }

  get nmInterface () {
    return this.interface
  }

  get pageSearchItem () {
    return GenaratorOrderPageSearchTable
  }

  get pageSearch () {
    return GeneratorOrderPageSearch
  }
}
export default GeneratorOrder
</script>
<style lang="stylus" scoped>
/deep/ td span {
  text-wrap: auto !important;
}
.clientCarrier{
  padding-top: 20px;

  .buttons-top-crud{
    display: none;
  }

  .label-crud-search{
    display: none;
  }

  .btNovo-btn i,
  .icAlterar-btn i,
  .icAtivar-btn i,
  .icInativar-btn i {
    padding-right: 10px;
  }

  .crudButtons .card-crud .table-crud .jt-datatable{
    height: 63vh!important;
  }
}
</style>
